/**
 * Enum for commonly used keyboard keys
 * Provides type safety and consistency for keyboard event handling
 */
export enum KeyboardKeys {
  ESCAPE = 'Escape',
  ENTER = 'Enter',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
}
